import React from "react";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type TData = {
  recycle: number;
  landfill: number;
  totalWaste: number;
  projects: number;
  wasteType: number;
};

const tempCardDatas: (items: TData) => {
  title: string;
  value: string | number;
}[] = ({ recycle, landfill, totalWaste, projects, wasteType }: TData) => {
  return [
    {
      title: "Recycled Waste",
      value: recycle?.toFixed(2),
    },
    {
      title: "Landfill Waste",
      value: landfill?.toFixed(2),
    },
    {
      title: "Total Waste",
      value: totalWaste?.toFixed(2),
    },
    {
      title: "No of Projects",
      value: projects,
    },

    {
      title: "No of Waste Type",
      value: wasteType,
    },
  ];
};

type TTempCard = {
  title: string;
  value: string | number;
};

type TProps = {
  singleDetail: TTempCard;
  isExport?: boolean;
};

const SingleCard: React.FC<TProps> = ({ singleDetail, isExport }) => {
  return (
    <Card className='overflow-hidden rounded-md text-primary'>
      <CardHeader>
        <p className='text-sm font-medium'>{singleDetail.title}</p>
      </CardHeader>
      <CardContent>
        <h2
          className={cn(
            "text-2xl font-semibold xl:text-3xl",
            isExport && "text-lg text-wrap",
          )}
        >
          {singleDetail.value as number}
        </h2>
      </CardContent>
    </Card>
  );
};

type TCardProps = {
  recoveryPathway: {
    RECYCLE: number;
    REUSE: number;
    LANDFILL: number;
    ENERGYCONVERSION: number;
  };
  noOfProjects: number;
  noOfWasteType: number;
  isExport?: boolean;
};

const Cards: React.FC<TCardProps> = ({
  recoveryPathway,
  noOfProjects,
  noOfWasteType,
  isExport,
}) => {
  const finalData = tempCardDatas({
    recycle: recoveryPathway?.RECYCLE || 0,
    landfill: recoveryPathway?.LANDFILL,
    totalWaste:
      (recoveryPathway?.RECYCLE || 0) +
      (recoveryPathway?.ENERGYCONVERSION || 0) +
      (recoveryPathway?.LANDFILL || 0) +
      (recoveryPathway?.REUSE || 0),
    projects: noOfProjects || 0,
    wasteType: noOfWasteType || 0,
  });

  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-col-3 lg:grid-cols-5 xl:grid-cols-5",
        isExport && "flex flex-wrap gap-4",
      )}
    >
      {finalData?.map((single: TTempCard, singleIdx) => {
        return (
          <SingleCard
            singleDetail={single}
            key={singleIdx}
            isExport={isExport}
          />
        );
      })}
    </div>
  );
};

export default Cards;
